<template>
    <el-dialog
        title="Campaign"
        :visible.sync="showForm"
        append-to-body
        :close-on-click-modal="false"
    >
      <budget-order-detail :data="order" v-if="order" v-loading="loading" @updated="refresh"></budget-order-detail>

        <span slot="footer" class="dialog-footer">
            <el-button @click="showForm = false">Close</el-button>
            <el-button type="primary" @click="save">Save</el-button>
        </span>
    </el-dialog>
</template>

<script>
import BudgetOrderDetail from "../budget-order/budget-order-detail";

export default {
      components: {BudgetOrderDetail},
      props: [
            'show',
            'data_id',
        ],
        data() {
            return {
                order: null,
                loading: true
            };
        },
        watch: {
            data_id(newId, oldId) {
                if (newId !== null) {
                    this.refresh();
                } else {
                    this.order = null;
                    this.loading = false;
                }
            }
        },
        computed: {
            showForm: {
                get() { return this.show; },
                set(val) { this.$emit('close'); }
            }
        },
        methods: {
            save() {
                return axios.post(url(`admin/budget-order/${this.data_id}`), {
                    'order': this.order
                }).then(response => {
                    this.showForm = false;
                });
            },
            refresh() {
                this.loading = true;
                axios.get(url(`admin/budget-order/${this.data_id}`))
                    .then((response) => {
                        this.order = response.data.order;
                        this.loading = false;
                    });
            }
        }
    }
</script>

<style>
  .cd-section {
    margin-top: 10px;
  }
</style>